import { useQuery } from "@tanstack/react-query";

import { SATOSPortal } from "@/DataAdapter/SATOSPortal";

import { Group, GroupResources } from "@/model/Group/Group";
import {
	GetUserGroupMembershipStatusResponse,
	GroupEmployee,
} from "@/model/User/Employee";

export const useFetchGroups = () => {
	return useQuery<Group[], any>({
		queryKey: [GroupQueryKeys.groups],
		queryFn: SATOSPortal.GetGroups,
	});
};

export const useFetchGroup = (groupId: number) => {
	return useQuery<Group, any>({
		queryKey: [GroupQueryKeys.groups, groupId],
		queryFn: () => SATOSPortal.GetGroup(groupId),
	});
};

export const useFetchUserGroupMembershipStatus = (groupId: number) => {
	return useQuery<GetUserGroupMembershipStatusResponse, any>({
		queryKey: [GroupQueryKeys.groups, groupId, GroupQueryKeys.members],
		queryFn: () => SATOSPortal.GetUserGroupMembershipStatus(groupId),
	});
};

export const useFetchGroupResources = (groupId: number) => {
	return useQuery<GroupResources, any>({
		queryKey: [GroupQueryKeys.groups, groupId, GroupQueryKeys.resources],
		queryFn: () => SATOSPortal.GetGroupResources(groupId),
	});
};

export class GroupQueryKeys {
	static readonly groups = "groups";
	static readonly members = "members";
	static readonly resources = "resources";
}
